import { Outlet, useLocation } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { LOGIN_PATH } from '@constants/cp-paths.js';
import { OMS_DASHBOARD_PATH, LOGIN_PATH as DUBIZZLE_LOGIN_PATH } from '@constants/seller-center-paths.js';
import { isOLXTenant } from '@utils/utils';
import { isCP } from '../../../utils/app-utils';

const ProtectedRoute = ({ user = true, redirect = true }) => {
  const location = useLocation();
  const cpRedirectURL = redirect ? `${LOGIN_PATH}?redirect_to=${location?.pathname}${location?.search}` : LOGIN_PATH;

  return user ? (
    <Outlet />
  ) : (
    <Navigate to={isCP() ? cpRedirectURL : /*isOLXTenant() ? OMS_DASHBOARD_PATH :*/ DUBIZZLE_LOGIN_PATH} />
  );
};

export default ProtectedRoute;
